import { render, staticRenderFns } from "./EmployeesOverview.vue?vue&type=template&id=5372e839&scoped=true&"
import script from "./EmployeesOverview.vue?vue&type=script&lang=js&"
export * from "./EmployeesOverview.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesOverview.vue?vue&type=style&index=0&id=5372e839&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5372e839",
  null
  
)

export default component.exports